import { loadFooterSettings } from "../../apis/footer";
import { atomWithQuery } from "jotai-tanstack-query";

export const footerSettingsAtom = atomWithQuery(() => ({
  queryKey: ["footerSettings"],
  queryFn: async () => {
    return loadFooterSettings();
  },
  staleTime: Infinity, // Footer settings rarely change
}));
